import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { Helmet } from "react-helmet";
import AppRoutes from "./routing/app-routes";
import Layout from "./routing/Layout";
import { useAgencyInfo } from "./context/agency";
import { useEffect } from "react";

function App() {
  const [agency] = useAgencyInfo();
  const routes = AppRoutes();

  console.log(agency?.customCode, "customCodecustomCodecustomCodecustomCodecustomCode");

  // Set favicon dynamically when agency data is loaded
  useEffect(() => {
    const Meta_logo = agency?.theme_id?.theme_data?.general?.Meta_logo;
    if (Meta_logo) {
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
      }
      link.href = Meta_logo;
    }
  }, [agency]);

 const injectHTML = (htmlString, target = "head") => {
  if (!htmlString) return;

  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = htmlString.trim();

  Array.from(tempDiv.childNodes).forEach((node) => {
    if (node.nodeType === Node.ELEMENT_NODE) {
      const tag = node.tagName.toLowerCase();

      if (tag === "script") {
        const newScript = document.createElement("script");

        // Copy all attributes
        Array.from(node.attributes).forEach((attr) =>
          newScript.setAttribute(attr.name, attr.value)
        );

        // Copy inline script content
        newScript.textContent = node.textContent;

        // Always append scripts at the end
        (target === "head" ? document.head : document.body).appendChild(newScript);
      } else {
        const clone = node.cloneNode(true);

        // If inserting into <body>, insert at the top
        if (target === "body") {
          document.body.insertBefore(clone, document.body.firstChild);
        } else {
          document.head.appendChild(clone); // <head> content goes at the end
        }
      }
    }
  });
};



// Inject headerCode into <head>
useEffect(() => {
  injectHTML(agency?.customCode?.headerCode, "head");
}, [agency?.customCode?.headerCode]);

// Inject bodyCode into <body>
useEffect(() => {
  injectHTML(agency?.customCode?.bodyCode, "body");
}, [agency?.customCode?.bodyCode]);


  const getRoutes = (allRoutes) => {
    return allRoutes.map((route) => {
      if (route.path) {
        return (
          <Route
            key={route.path}
            path={route.path}
            element={
              route?.layout === "blank" ? (
                route.element
              ) : (
                <Layout>{route.element}</Layout>
              )
            }
          />
        );
      }

      return null;
    });
  };

  const pageTitle =
    agency?.theme_id?.theme_data?.general?.home_m_title || "Loading...";
  const pageDescription =
    agency?.theme_id?.theme_data?.general?.home_m_description ||
    "Discover and list local businesses with ease. Users can submit their business profiles for admin approval, and once verified, get featured on our public directory to boost visibility and reach.";

  return (
    <div>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <link
          rel="icon"
          href={
            agency?.theme_id?.theme_data?.general?.Meta_logo ||
            "https://snapshotstore.fra1.digitaloceanspaces.com/Untitled%20design%20%287%29-83731"
          }
        />
      </Helmet>

      <Routes>{getRoutes(routes)}</Routes>

      <Toaster />
    </div>
  );
}

export default App;

